import { ReactElement, useContext, useState } from "react";
import moment from "moment";
import "./CheckOutList.css";
import { ReactComponent as ArrowDownIcon } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as CartIcon } from "../../assets/icons/shopping_cart.svg";
import { total } from "../CheckOutPayment/PaymentDirect";
import { currency } from "../../utilities/misc";
import CheckOutSummary, { CouponForm } from "./CheckOutSummary";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import { CartTotalContext, LocaleContext } from "../../AppProvider";
import { DateTimeInfoHeader } from "../CheckOutAddress/CheckOutAddress";
import { orderType } from "../../state_management/reducers/order";

const CheckOutListReschedule = ({
  buttonJSX,
  cart,
  gift_services,
  extras,
  cartCouponTotal,
  coupon,
  couponLoading,
  couponCheck,
  time_end,
  time_start,
  orderDetails
}: {
  buttonJSX: ReactElement;
  cartCouponTotal: number | null;
  cart: cartItem[];
  gift_services: cartItem[];
  extras: extrasCartItem[];
  coupon: string | null;
  couponLoading?: boolean;
  couponCheck?: boolean;
  time_start: string;
  time_end: string;
  orderDetails: orderType;
} & (
  | {
      couponLoading: boolean;
      couponCheck?: never;
    }
  | {
      couponLoading?: never;
      couponCheck: true;
    }
)) => {
  const { t, locale } = useContext(LocaleContext);
  const [cartTotal] = useContext(CartTotalContext);
  const [listOpen, setListOpen] = useState(false);

  const Total = total(cartCouponTotal, cartTotal);

  const date = moment(time_start).format("YYYY-MM-DD");
  const startTime = moment(time_start).format("HH:mm");

  const endTime = moment(time_end).format("HH:mm");

  return (
    <>
      <div className="checkOutList_wrapper">
        <div className="checkOutList_wrapper_lg">
          <DateTimeInfoHeader
            date={date}
            endTime={endTime}
            startTime={startTime}
          />
          <CheckOutSummary
            buttonJSX={buttonJSX}
            cartMerged={{
              cart,
              extras,
              gift_values: gift_services
            }}
            cartTotal={cartTotal}
            cartWithCouponTotal={Total}
            coupon={coupon}
            deactivateBars
            couponCheck={!!couponCheck}
            couponLoading={!!couponLoading}
            orderDetails={orderDetails}
          />
        </div>
        <div className="checkOutList_wrapper_sm">
          <div
            onClick={() => setListOpen(!listOpen)}
            className="checkout_list_collapse_wrapper"
          >
            <div className="flex1 flex">
              <CartIcon className="cartIcon" />
              <div>
                <span className="collapse_title fontBlue">
                  {t("Show order summary")}
                </span>
                <span>
                  <ArrowDownIcon className="arrowIcon" />
                </span>
              </div>
            </div>
            <div className="fontBlue med_text">
              {currency(Total.toFixed(2), locale)}
            </div>
          </div>
          {listOpen && (
            <div className="checkout_collapse_list">
              <CheckOutSummary
                buttonJSX={<></>}
                cartMerged={{ cart, extras, gift_values: gift_services }}
                cartTotal={cartTotal}
                cartWithCouponTotal={Total}
                coupon={coupon}
                deactivateBars
                couponCheck={!!couponCheck}
                couponLoading={!!couponLoading}
                orderDetails={orderDetails}
              />
            </div>
          )}
        </div>
      </div>
      <div className="couponForm_wrapper_sm">
        <CouponForm
          isSmall
          cart={cart}
          extras={extras}
          gift_values={gift_services}
          couponCheck={!!couponCheck}
          orderDetails={orderDetails}
          deactivateBars
        />
        <DateTimeInfoHeader
          date={date}
          endTime={endTime}
          startTime={startTime}
        />
      </div>
    </>
  );
};

export default CheckOutListReschedule;
